import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, token: String, fingerprint: String }

  record(event) {
    if (event.button > 1 || this.recorded) return
    this.recorded = true
    // Do not delay or replace normal link navigation. The server rechecks consent.
    fetch(this.urlValue, {
      method: "POST", credentials: "same-origin", keepalive: true,
      headers: { "Content-Type": "application/json", Accept: "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" },
      body: JSON.stringify({ document_token: this.tokenValue, fingerprint: this.fingerprintValue })
    }).catch(() => {})
  }
}
